import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { Stepper, StepperChangingEventArgs } from '@syncfusion/ej2-angular-navigations';
import { SharedService } from 'src/app/core/services/shared.service';
import { ChangeDetectorRef } from '@angular/core';
import Swal from 'sweetalert2';
import { EventService } from 'src/app/core/services/event.service';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit, AfterViewInit {

  @ViewChild('validationStepper') stepperObj: Stepper;
  
  public Formularios: FormGroup[] = [];
  public dataEncuestas: any;
  public activeStep: number = 0;
  public hayErrores: boolean = false;
  public formOk : any[] = [];
  public estadoForm : String;

  public intSYS02CON: string;
  TiempoBackend : number = 0;
  TiempoFinal  = new Date();
  TiempoInicio =  new Date();

  @Input() WsLlaves;
  @Input() EventoCerrarMSNavID: string = '';
  @Input() Tipo: string;
  @Output() EventoCerrarMsInterno = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder, private dataService: SharedService, private cd: ChangeDetectorRef, private eventService: EventService) { }

  ngOnInit(): void {
    if(this.Tipo == "Aplicada"){
      setTimeout(() => {
        this.CargarFormulario(); 
      }, 200);
    }else{
      this.CrearFormulario(); 
    }
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
    if (this.stepperObj && this.dataEncuestas) {
      this.stepperObj.refresh(); 
      this.stepperObj.activeStep = this.activeStep; 
    }
  }

  onValueChanged(value: number, preguntaId: string, formGroup: FormGroup): void {
    const control = formGroup.get(preguntaId);
    if (control) {
        control.setValue(value);
        control.markAsTouched();
    }
  }

  StepChange(args: StepperChangingEventArgs): void {
    this.activeStep = args.activeStep;  
  }

  StepCreated(): void {
    this.activeStep = this.activeStep;  
  }

  CrearFormulario(): void {

    let objetoJSON = {
      LLAVES: this.WsLlaves
    };

    this.dataService.ConsultarWS('api/ws/cli/CLI11ARC_WS/NuevaEncuesta/ldCLI11ARC', JSON.stringify(objetoJSON)).subscribe((datosResp: any) => {
        if (datosResp && datosResp.CLI10COD) {
            this.dataEncuestas = datosResp;
            let contador = 0;

            this.estadoForm = datosResp.CLI10EST;

            this.Formularios = datosResp.CLI16ARC.map(seccion => {
                this.formOk.push({index:contador, value: false});
                const group = seccion.CLI11ARC.reduce((obj, pregunta) => {
                  let validators = [];
                  if (pregunta.CLI01REQ === 'S') {
                      validators.push(Validators.required);
                  }
                  if(pregunta.CLI01TRE === 'A'){
                    if(pregunta.CLI01CAP === 'AB'){ // solo alfabeto
                      obj[pregunta.CLI11COD] = new FormControl('', {
                        validators: [
                            Validators.required,
                            Validators.pattern(/^[a-zA-Z\s]*$/) 
                        ]
                      });
                    } else if (pregunta.CLI01CAP === 'CE') { // solo caracteres especiales
                      obj[pregunta.CLI11COD] = new FormControl('', {
                          validators: [
                              Validators.required,
                              Validators.pattern(/^[a-zA-Z0-9]*$/) 
                          ]
                      });
                  }else if (pregunta.CLI01CAP === 'NU') { // Solo números
                    obj[pregunta.CLI11COD] = new FormControl('', {
                        validators: [
                            Validators.required,
                            Validators.pattern(/^[0-9]*$/)
                        ]
                    });
                  }else{
                        obj[pregunta.CLI11COD] = new FormControl('', validators);
                      }
                    }
                    else if (pregunta.CLI01TRE === 'SM') {
                        obj[pregunta.CLI11COD] = this.fb.array(
                            pregunta.CLI20ARC.map(() => new FormControl(false)),
                            { validators: this.minSelectedCheckboxes(1) } 
                        );
                    } else if (pregunta.CLI01TRE === 'GR' || pregunta.CLI01TRE === 'CL') {
                        validators.push(this.noZeroValidator());
                        obj[pregunta.CLI11COD] = new FormControl(0, validators);
                    } else {
                        obj[pregunta.CLI11COD] = new FormControl('', validators);
                    }
                    return obj;
                }, {});
                contador++;
                return new FormGroup(group);
            });

            if (this.stepperObj) {
                this.stepperObj.refresh();
                this.stepperObj.activeStep = this.activeStep;
            }
        }
    });
  }

  CargarFormulario(): void {

    let objetoJSON = {
      LLAVES: this.WsLlaves
    };

    this.dataService.ConsultarWS('api/ws/cli/CLI11ARC_WS/Encuesta/ldCLI11ARC', JSON.stringify(objetoJSON)).subscribe((datosResp: any) => {
        if (datosResp && datosResp.CLI10COD) {
            this.dataEncuestas = datosResp;
            let contador = 0;

            this.estadoForm = datosResp.CLI10EST;

            this.Formularios = datosResp.CLI16ARC.map(seccion => {
                this.formOk.push({index:contador, value: true});
                const group = seccion.CLI11ARC.reduce((obj, pregunta) => {
                  let validators = [];
                 
                  if(pregunta.CLI01TRE === 'A'){
                      obj[pregunta.CLI11COD] = new FormControl(this.Tipo === "Aplicada" ? pregunta.CLI20ARC[0].CLI22RES : '', {});
                    }
                    else if (pregunta.CLI01TRE === 'SM') {
                        obj[pregunta.CLI11COD] = this.fb.array(
                            pregunta.CLI20ARC.map(() => new FormControl(false)),{} );
                    } else if (pregunta.CLI01TRE === 'GR' || pregunta.CLI01TRE === 'CL') {
                        obj[pregunta.CLI11COD] = new FormControl(0, validators);
                    } else {
                        obj[pregunta.CLI11COD] = new FormControl('', validators);
                    }
                    return obj;
                }, {});
                contador++;
                return new FormGroup(group);
            });

            if (this.stepperObj) {
                this.stepperObj.refresh();
                this.stepperObj.activeStep = this.activeStep;
            }
        }
    });
  }

  noZeroValidator(): Validators {
    return (control: FormControl) => {
        const value = control.value;
        return value !== 0 ? null : { noZero: true };
    };
  }
  minSelectedCheckboxes(min: number) {
    return (formArray: FormArray) => {
      const totalSelected = formArray.controls
        .map(control => control.value)
        .reduce((prev, next) => next ? prev + 1 : prev, 0);

      return totalSelected >= min ? null : { required: true };
    };
  }

  previousStep(): void {
    if (this.activeStep > 0) {
      this.activeStep--;
    }
  }

  nextStep(): void {
    const currentFormGroup = this.Formularios[this.activeStep];
    if (currentFormGroup.invalid) {
      currentFormGroup.markAllAsTouched();
      return;
    }

    if (this.activeStep < this.Formularios.length - 1) {
      this.formOk[this.activeStep].value = true;
      this.activeStep++;
    } else {
      this.confirmar();
    }
  }

  CerrarMsInternoClick(blnRefrescar: boolean) {
    this.EventoCerrarMsInterno.emit(blnRefrescar);
  }

  confirmar(): void {
    
    const todosValidos = this.Formularios.every(formGroup => formGroup.valid);

    if(this.Tipo == "Test"){
      Swal.fire({
        html:
          '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
          '<div class="col-5">' +
          ' <img src="assets/images/imageerror.png"> </img>' +
          "</div>" +
          ' <div class="col-7">' +
          "<h3>Advertencia</h3><br>" +
          " <p>" +
          "La acción no es valida, modo test." +
          "</p>" +
          " </div> ",
      });
      return;
    }else if(this.Tipo == "Aplicada"){
      return;
    }
  
    if (todosValidos) {
      Swal.fire({
        title: '¿Estás seguro?',
        text: '¿Deseas enviar la encuesta?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, enviar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.hayErrores = false;
          this.formOk.forEach((formStatus, index) => {
            formStatus.value = true;
          });
  
          const respuestasJson = this.generarJsonRespuestas();
          console.log('JSON de respuestas:', JSON.stringify(respuestasJson, null, 2));
  
          this.dataService.ConsultarWS('api/ws/cli/CLI21ARC_WS/ResponderEncuesta/ldCLI11ARC', respuestasJson).subscribe(
            (datosResp: any) => {
              Swal.fire({
                icon: 'success',
                title: 'Encuesta completada',
                text: '¡La encuesta fue contestada con satisfacción!',
                confirmButtonText: 'Aceptar'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.eventService.broadcast("EventoCerrarMS_" + this.EventoCerrarMSNavID, JSON.parse('{}'));
                  this.CerrarMsInternoClick(false);
                }
              });
            },
            (error) => {
              Swal.fire({
                html:
                  '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                  '<div class="col-5">' +
                  ' <img src="assets/images/imageerror.png"> </img>' +
                  "</div>" +
                  ' <div class="col-7">' +
                  "<h3>Error</h3><br>" +
                  " <p>" +
                  error +
                  "</p>" +
                  " </div> ",
              });
            }
          );
        } else {
          console.log('El usuario canceló el envío.');
        }
      });
    } else {
      this.Formularios.forEach(formGroup => formGroup.markAllAsTouched());
      this.hayErrores = true;
      this.formOk[this.activeStep].value = false;
    }
  }
  


  generarJsonRespuestas(): any {
    const respuestas = this.Formularios.flatMap((formGroup, index) => {
        const seccion = this.dataEncuestas.CLI16ARC[index];
        return seccion.CLI11ARC.flatMap(pregunta => {
            const control = formGroup.get(pregunta.CLI11COD);
            let respuesta;

            if (pregunta.CLI01TRE === 'SM') {
                // Para selección múltiple, mapear los valores seleccionados
                respuesta = control.value
                    .map((checked, i) => checked ? pregunta.CLI20ARC[i].CLI20COD : null)
                    .filter(v => v !== null);
            } else {
                // Para preguntas abiertas o de una sola respuesta
                respuesta = control.value;
            }

            // Si es una respuesta múltiple, generar múltiples objetos
            if (Array.isArray(respuesta)) {
              const unicaRespuesta = Array.from(new Set(respuesta.map(res => String(res))));
              return unicaRespuesta.map(res => {
                  // Encuentra el elemento correspondiente en CLI20ARC
                  const elementoSeleccionado = pregunta.CLI20ARC.find(opcion => opcion.CLI20COD === res);
                  
                  return {
                      CLI11COD: pregunta.CLI11COD,
                      CLI22RES: String(res), 
                      CLI20COD: elementoSeleccionado ? elementoSeleccionado.CLI20COD : ""
                  };
              });
            }
          

            // se obtiene el CLI20COD segun respuesta seleccionada
            let CLI20COD = "";
            if(pregunta.CLI20ARC.length > 0){
              for (let i = 0; i < pregunta.CLI20ARC.length; i++) {
                if(pregunta.CLI01TRE == 'C' || pregunta.CLI01TRE == 'CL'){ // Respuesta unica || Respuesta calificación
                  if(pregunta.CLI20ARC[i].CLI20COD == respuesta){
                    CLI20COD = pregunta.CLI20ARC[i].CLI20COD;
                    break;
                  }
                }else if(pregunta.CLI01TRE == 'GR'){ // Respuesta valor Slider
                  if(pregunta.CLI20ARC[i].CLI02ENU == respuesta){
                    CLI20COD = pregunta.CLI20ARC[i].CLI20COD;
                    break;
                  }
                }
              }
            }

            // Para respuestas simples o preguntas abiertas, devolver un solo objeto
            return [{
                CLI11COD: pregunta.CLI11COD,
                CLI22RES: String(respuesta), 
                CLI20COD: CLI20COD
            }];
        });
    });

    return {
        LLAVES: [{ CLI10COD: this.dataEncuestas.CLI10COD }],
        CLI22ARC: respuestas
    };
  }

  getRemarks(lstCLI20ARC: any): any[] {
    let lst:any = [];
    let descripcion = '';
    for (let index = 0; index < lstCLI20ARC.length; index++) {
      lst.push(lstCLI20ARC[index]["CLI02ETQ"] == undefined ? '' : lstCLI20ARC[index]["CLI02ETQ"]);
    }
    return lst;
  }

  getMin(lstCLI20ARC: any): number {
    let min: number = Number.MAX_VALUE; 
  
    for (let index = 0; index < lstCLI20ARC.length; index++) {
      let valor = Number(lstCLI20ARC[index]["CLI02ENU"]);
      
      if (valor < min) {
        min = valor; 
      }
    }
  
    return min !== Number.MAX_VALUE ? min : 0; 
  }
  
  
  getMax(lstCLI20ARC: any): number {
    let max: number = Number.MIN_VALUE; 
  
    for (let index = 0; index < lstCLI20ARC.length; index++) {
      let valor = Number(lstCLI20ARC[index]["CLI02ENU"]);
      
      if (valor > max) {
        max = valor; 
      }
    }
  
    return max !== Number.MIN_VALUE ? max : 0; 
  }
  
  getTags(lstCLI20ARC: any): any[] {
    let lst:any = [];
    for (let index = 0; index < lstCLI20ARC.length; index++) {
      lst.push(lstCLI20ARC[index]["CLI02ETQ"]);
    }
    return lst;
  }

  getCLI22RES(lstCLI20ARC: any): any[] {
    let res:any = 0;
    for (let index = 0; index < lstCLI20ARC.length; index++) {
      if(lstCLI20ARC[index]["CLI22RES"] !== undefined){
        res = lstCLI20ARC[index]["CLI22RES"];
        break;
      }
    }
    return res;
  }

  DiferenciaTiempo(){
    return (this.TiempoFinal.getTime()  - this.TiempoInicio.getTime()) / 1000.0;
  }
  
}
